import React from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import Checkbox from '../../Checkbox/Checkbox';
import MenuItemStyled from '../../DropDown/shared/MenuItemStyled';
import { DropDownOption } from '../../DropDown/types';
import { Flex, FlexColumn } from '../../Flex';
import OverflowTooltip from '../../OverflowTooltip';

const MenuItemWrapper = styled.div`
  padding-left: 4px;
  padding-right: 4px;
`;

const OptionContentContainer = styled(Flex)`
  align-items: center;
  overflow-x: hidden;
  width: 100%;
  gap: 8px;
  padding-right: 8px;
`;

const OptionTextContainer = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 98%;
`;

const CounterText = styled(Typography)`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.common.gray2};
`;

interface OptionItemProps {
  option: DropDownOption;
  isSelected: boolean;
  multiple?: boolean;
  showCounter?: boolean;
  optionRenderer?: (val: string) => string;
  emptyValueLabel: string;
  onClick: (e: React.MouseEvent) => void;
}

const OptionItem = ({
  option,
  isSelected,
  multiple,
  showCounter,
  optionRenderer,
  emptyValueLabel,
  onClick,
}: OptionItemProps) => (
  <MenuItemWrapper>
    <MenuItemStyled
      value={option.value}
      onClick={onClick}
      $multiple={multiple}
      selected={isSelected}
      $hasDescription={!!option.description}
      disabled={option.disabled}
    >
      {multiple && <Checkbox checked={isSelected} />}
      <OptionContentContainer>
        <Flex>{option.icon}</Flex>
        <OptionTextContainer>
          {optionRenderer ? (
            optionRenderer(option.value)
          ) : (
            <FlexColumn width="98%" gap={0.2}>
              <OverflowTooltip
                typographySx={{ maxWidth: '98%' }}
                aria-label="dropdown-option"
              >
                {option.label || emptyValueLabel}
              </OverflowTooltip>
              {option.description && (
                <OverflowTooltip
                  typographySx={{
                    maxWidth: '98%',
                    fontSize: '12px',
                    lineHeight: 'normal',
                    color: 'common.gray4',
                  }}
                >
                  {option.description}
                </OverflowTooltip>
              )}
            </FlexColumn>
          )}
          {showCounter && <CounterText>{option.counter || 0}</CounterText>}
        </OptionTextContainer>
      </OptionContentContainer>
    </MenuItemStyled>
  </MenuItemWrapper>
);

export default OptionItem;
